import { TermsAndPrivacyData } from './TermsAndPrivacy.consts';
import Logo from '..//../assets/report-logo.svg';
import { PATHS } from '../../constants/Paths.constants';

export function TermsAndPrivacyContent({
  activeTab
}: {
  activeTab: 'terms' | 'policy';
}) {
  const contentData = TermsAndPrivacyData[activeTab];

  const renderParagraph = (text: string) => {
    const email = 'compliai@skyhighgrowth.com';

    // if paragraph contains the email, split and render clickable link
    if (text.includes(email)) {
      const parts = text.split(email);

      return (
        <>
          {parts[0]}
          <a href={`mailto:${email}`} className="underline-custom">
            {email}
          </a>
          {parts[1]}
        </>
      );
    }

    return text;
  };

  return (
    <div className="flex flex-col justify-center items-center">
      <div className="max-w-[733px] flex flex-col gap-14 py-14">
        {/* Header */}
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-2">
            <span className="text-purple-600 font-semibold uppercase">
              Current as of 15 Nov 2025
            </span>
            <h1 className="text-zinc-900 text-4xl font-extrabold">
              {contentData.header.title}
            </h1>
          </div>
          {activeTab === 'terms' && (
            <div className="text-gray-800 text-xl leading-8">
              {contentData.header.description}
            </div>
          )}
        </div>

        {contentData.content.map((data, index) => (
          <div key={data.title} className="flex flex-col gap-8">
            <h2 className="text-zinc-900 text-3xl leading-10 text-left font-bold">
              {data.title}
            </h2>

            {/* Sections */}
            {data.sections.map((section) => {
              if (section.type === 'keyValue') {
                return (
                  <div key={section.type}>
                    {section.items.map((item) => (
                      <p
                        key={item.label}
                        className="text-lg text-gray-800 text-left leading-8"
                      >
                        <span className="font-semibold">{item.label}:</span>{' '}
                        {renderParagraph(item.value)}
                      </p>
                    ))}
                  </div>
                );
              }

              if (section.type === 'bullets') {
                return (
                  <ul
                    key={section.type}
                    className="list-none pl-5 space-y-3 text-lg text-gray-800 text-left leading-8"
                  >
                    {section.items.map((bullet) => (
                      <li
                        key={bullet.text}
                        className="relative pl-6 before:content-[''] before:absolute before:left-0 before:top-[11px] before:w-1.5 before:h-1.5 before:rounded-full before:bg-gray-200"
                      >
                        {bullet.text}

                        {bullet.subItems && (
                          <ul className="pl-3 mt-2 space-y-1">
                            {bullet.subItems.map((sub) => (
                              <li
                                key={sub}
                                className="pl-[20px] [list-style-type:'–'] [&::marker]:text-gray-200"
                              >
                                {sub}
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                );
              }

              if (section.type === 'paragraph') {
                return (
                  <p
                    key={section.text}
                    className="text-lg text-gray-800 text-justify leading-8 whitespace-pre-line"
                  >
                    {renderParagraph(section.text)}
                  </p>
                );
              }

              if (section.type === 'paragraphGroup') {
                return (
                  <div className="text-lg text-gray-800 text-left leading-8">
                    {section.text.map((text) => (
                      <p>{renderParagraph(text)}</p>
                    ))}
                  </div>
                );
              }

              return null;
            })}
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="w-full flex flex-col justify-center items-center border-t bordre-gray-300 pt-16 pb-12 px-8">
        <a href={PATHS.REGISTRATION} className="mb-6">
          <img src={Logo} alt="logo" className="w-[141px] h-12" />
        </a>
        <p className="text-xs text-gray-900 leading-5 mb-2">
          For inquiries, contact:{' '}
          <a className="underline-custom" href="mailto:">
            compliai@skyhighgrowth.com
          </a>
        </p>
        <p className="text-zinc-900 self-end">
          © 2025 CompliAI. All rights reserved.
        </p>
      </div>
    </div>
  );
}
